<template>
  <TableStatic :loading="loading" :rows="rows" :columns="columns" :line-numbers="lineNumbers">
    <template slot="table-row" slot-scope="props">
      <div v-if="props.column.field === 'orgCode'">
        <p>{{ props.row.orgCode }}</p>
        <p>{{ props.row.orgCode2 }}</p>
      </div>
      <template v-else-if="props.column.field === 'advAmount'">
        {{ (parseInt(props.row.advAmount, 10) * 100) | currency }}
      </template>
      <strong v-else-if="props.column.field === 'balance'">
        {{ (parseInt(props.row.balance, 10) * 100) | currency }}
      </strong>
      <template v-else-if="props.column.field === 'loanClassCode'">
        <div :class="{ 'status is-confirmed': props.row.loanClassCode?.includes('хэвийн') }">
          {{ props.row.loanClassCode }}
        </div>
      </template>
    </template>
  </TableStatic>
</template>

<script>
import TableStatic from '@/components/ui/table/TableStatic';
import tableMixin from '@/mixins/tableMixin';
import humps from 'humps';

export default {
  mixins: [tableMixin],
  components: {
    TableStatic,
  },
  methods: {
    getStatus(status) {
      return status ? humps.camelize(status).toLowerCase() : '';
    },
  },
};
</script>
